export default __webpack_public_path__ + "static/media/WorkSans-Medium.1ce950d5.woff";